module.exports = __webpack_public_path__ + "static/media/cks_logo.b92f02fb.png";